import Dialog from "@components/Dialog"
import { Table } from "@components/Table"
import { MRT_ColumnDef } from "material-react-table"

export type RunGroupError = {
  status: number
  data: {
    detail: {
      class: string
      df: string // stringified json
      error: string
    }
  }
}

type RunGroupErrorDialogProps = {
  rows: Row[]
  error: string
  onClose: () => void
}

export type Row = {
  calibrationMnem: string
  forecastMnem: string
  id: string //node id
  lag: number
  lagDuplicate: string
  name: string
  newName: string
  nodeCalculation: string
  scenarioMnem: string
}

const RunErrorDialog = (props: RunGroupErrorDialogProps) => {
  const columns: MRT_ColumnDef<Row>[] = Object.keys(props.rows?.[0] ?? {}).map((key) => ({
    accessorKey: key,
    header: key,
  }))

  return (
    <Dialog open onClose={props.onClose} title={props.error} fullScreen>
      <Table
        data={props.rows}
        columns={columns}
        sessionStorageName="run-group-errors"
        isExportable
        isExportableSelection={false}
        isExportableRows={false}
        rowCount={props.rows.length}
      />
    </Dialog>
  )
}

export default RunErrorDialog
